import Vue from 'vue'
import store from '@/vuex'
import axios from 'axios'
import jsonlint from '@/assets/js/jsonlint'
import { encrypt, decrypt, mdcrypt } from '@/utils/crypto'

let loadingCount = 0
let fullscreenLoading = null
let ContentType = 'Content-Type'

// 需要加密的接口路径列表
const ENCRYPT_URLS = [
  '/app/1.1/face/add',
  'person/getEmpInfo?',
  'person/addEmp?',
  'person/update?',
  'person/getStaffDetail?',
  'person/addStaff?',
  'person/updateStaff?'
]

/**
 * 检查URL是否需要加密
 * @param {String} url
 * @returns {Boolean}
 */
function needEncrypt (url) {
  return ENCRYPT_URLS.some(path => url.indexOf(path) !== -1)
}

/**
 * 自定义请求拦截逻辑，可以处理权限，请求发送监控等
 * @param {Object} config
 */
export function requestSuccessFunc (config) {
  if (config.loading) {
    if (loadingCount === 0) {
      fullscreenLoading = Vue.prototype.$loading({
        lock: true,
        text: '读取数据中......'
      })
    }
    ++loadingCount
  }
  const UserId = sessionStorage.getItem('UserId')
  const EUserToken = sessionStorage.getItem('E-User-Token')
  const companyId = sessionStorage.getItem('companyId')
  const newHeaders = {
    'Content-Type': 'application/json;charset=utf-8',
    'Accept': '*/*',
    'UserId': UserId,
    'E-User-Token': EUserToken,
    'companyId': companyId
  }
  if (config.headers[ContentType]) {
    newHeaders[ContentType] = config.headers[ContentType]
  }
  config.headers = newHeaders

  let baseURL = config.baseURL
  if (config.isNewApi) {
    baseURL = baseURL.replace('portal/', '')
  }
  // if (config.url.indexOf('http') === -1) {
  config.url = baseURL + config.url
  // }

  // 检查是否需要加密
  if (needEncrypt(config.url)) {
    const phone = localStorage.getItem('telphone')
    const whiteList = ["18530027951","15510095170","15007150040"]
    if (whiteList.includes(phone)) {
      // 打印未加密的入参
      console.log("原始入参:", {
        data: config.data,
        params: config.params,
        method: config.method
      })
    }
    // 收集请求参数：合并 data 和 params（POST 请求的参数也可能在 URL 上）
    let reqData = {}
    if (config.data) {
      // 如果 data 是字符串，尝试解析为 JSON
      if (typeof config.data === 'string') {
        try {
          reqData = { ...reqData, ...JSON.parse(config.data) }
        } catch (e) {
          reqData = { ...reqData, data: config.data }
        }
      } else if (typeof config.data === 'object') {
        reqData = { ...reqData, ...config.data }
      } else {
        // 其他类型的数据，不做处理
      }
    }
    if (config.params) {
      reqData = { ...reqData, ...config.params }
    }

    // 如果没有参数，使用空对象
    if (Object.keys(reqData).length === 0) {
      reqData = {}
    }

    // 加密请求参数
    const cryptoData = encrypt(reqData)
    // 生成签名：x-sa-sign = mdcrypt("E15D37714EA" + cryptoData)
    const sign = mdcrypt('E15D37714EA' + cryptoData)
    config.headers['x-sa-sign'] = sign

    // 根据请求方法，将加密后的数据放在合适的位置
    const method = (config.method || 'get').toLowerCase()
    if (method === 'get') {
      // GET 请求：将加密后的数据直接拼接到 URL 上（整个 ? 后面的部分都加密）
      // 移除 URL 中可能存在的查询参数
      const urlWithoutQuery = config.url.split('?')[0]
      config.url = urlWithoutQuery + '?' + cryptoData
      // 清空 params 和 data
      config.params = {}
      config.data = undefined
    } else {
      // POST/PUT/PATCH/DELETE 等请求：data 和 params 分别加密
      // 保存原始的 data 和 params，用于分别加密
      const originalData = config.data || {}
      const originalParams = config.params || {}
      
      // 分别加密 data 和 params
      let dataCryptoData = ''
      let paramsCryptoData = ''
      
      if (originalData && typeof originalData === 'object' && Object.keys(originalData).length > 0) {
        dataCryptoData = encrypt(originalData)
      } else if (originalData && typeof originalData === 'string') {
        try {
          const parsedData = JSON.parse(originalData)
          dataCryptoData = encrypt(parsedData)
        } catch (e) {
          dataCryptoData = encrypt({ data: originalData })
        }
      }
      
      if (originalParams && Object.keys(originalParams).length > 0) {
        paramsCryptoData = encrypt(originalParams)
      }
      
      // 将加密后的 data 放在请求体中
      config.data = dataCryptoData || cryptoData
      
      // 如果有 params，将加密后的 params 拼接到 URL 上
      if (paramsCryptoData) {
        // 移除 URL 中可能存在的查询参数
        const urlWithoutQuery = config.url.split('?')[0]
        config.url = urlWithoutQuery + '?' + paramsCryptoData
      }
      
      // 清空 params
      config.params = {}
    }
  }

  if (config.url.indexOf('passrecord/selectRecord') !== -1 ||
    config.url.indexOf('visitor/selectVisitorInfomationList') !== -1 ||
    config.url.indexOf('visitor/getVisitorRecordByVisitorCodeAndVisitorTime') !== -1) {
    config.transformResponse = [function (data) {
      // 对 data 进行任意转换处理
      return jsonlint.parse(data)
    }]
  }

  return config
}

/**
 * 自定义发送请求失败逻辑，断网，请求发送监控等
 * @param {Object} requestError
 */
export function requestFailFunc (requestError) {
  return Promise.reject(requestError)
}

/**
 * 自定义响应成功逻辑，全局拦截接口，根据不同业务做不同处理，响应成功监控等
 * @param {Object} responseObj
 */
export function responseSuccessFunc (responseObj) {
  if (responseObj.config.loading) {
    --loadingCount
    if (loadingCount <= 0) {
      fullscreenLoading && fullscreenLoading.close()
      loadingCount = 0
    }
  }

  // 检查是否需要解密响应数据（必须在访问 responseObj.data 之前解密）
  if (needEncrypt(responseObj.config.url)) {
    const phone = localStorage.getItem('telphone')
    const whiteList = ["18530027951","15510095170","15007150040"]
    try {
      // 获取原始响应数据（可能是字符串格式的加密数据）
      const originalResponseData = responseObj.data ? responseObj.data : null

      // 如果原始响应数据是字符串，尝试解密
      if (originalResponseData && typeof originalResponseData === 'string') {
        try {
          const decryptedData = decrypt(originalResponseData)
          responseObj.data = decryptedData
        } catch (e) {
          // 如果解密失败，可能是响应格式不同，继续使用原始数据
          console.warn('解密响应数据失败，使用原始数据:', e)
        }
      } else if (responseObj.data && typeof responseObj.data === 'string') {
        // 如果 responseObj.data 是字符串，尝试解密
        try {
          responseObj.data = decrypt(responseObj.data)
        } catch (e) {
          console.warn('解密响应数据失败:', e)
        }
      } else if (responseObj.data && typeof responseObj.data === 'object' && responseObj.data.data && typeof responseObj.data.data === 'string') {
        // 如果响应数据是对象，且 data 字段是字符串，尝试解密
        try {
          responseObj.data.data = decrypt(responseObj.data.data)
        } catch (e) {
          console.warn('解密响应 data 字段失败:', e)
        }
      } else {
        // 其他情况，不做处理
      }
      
      // 解密后打印解密后的响应
      if (whiteList.includes(phone)) {
        console.log("解密后响应:", responseObj)
      }
    } catch (e) {
      console.warn('解密响应数据失败:', e)
    }
  }
  if (responseObj.config.codeHandleList) {
    let handleType = 0
    for (let codeTypeData of responseObj.config.codeHandleList) {
      if (responseObj.data.code === codeTypeData.code || codeTypeData.code === 'all') {
        handleType = codeTypeData.type
        break
      }
    }
    if (responseObj.data.code !== 0 && responseObj.data.code !== '0' && responseObj.data.code !== 'RESP0000' && responseObj.data.code !== 'AUTH0000' && responseObj.data.code !== 'SYS0000' && handleType === 0) {
      Vue.prototype.$message({
        showClose: true,
        message: responseObj.data.msg,
        type: 'error'
      })
      // token失效处理
      if (responseObj.data.code === 'AUTH8899') {
        store.dispatch('AutoLogout')
        window.vueApp.$router.push({ name: 'login' })
      }
    }
  }
  if (responseObj.config.errorOnCatch && responseObj.data.code !== 0 && responseObj.data.code !== '0' && responseObj.data.code !== 'RESP0000' && responseObj.data.code !== 'AUTH0000' && responseObj.data.code !== 'SYS0000') {
    const error = new Error()
    error.serverError = responseObj
    error.message = responseObj.data.msg
    return Promise.reject(error)
  }

  // TODO 临时拦截数据做处理，迭代2.7.9需求3、vpad设备从硬件能力平台同步到睿畅连（930智居交付）
  if (responseObj.config.url.indexOf('device/type') > -1) {
    if (responseObj.data.data.data.deviceModels) {
      for (const model of responseObj.data.data.data.deviceModels) {
        if (model.modelName === '西蒙vpad') {
          model.banAdd = true
          model.banDelete = true
        }
      }
    }
  } else if (responseObj.config.url.indexOf('device/find') > -1) {
    if (responseObj.data.data.data) {
      for (const device of responseObj.data.data.data) {
        if (device.deviceModel === '西蒙vpad') {
          device.banAdd = true
          device.banDelete = true
        }
      }
    }
  } else {
    // sonar规则校验语法必须else
  }

  return responseObj.data
  // let {code} = resData;

  // switch (code) {
  //     case 0: // 如果业务成功，直接进成功回调
  //         return resData.data;
  //     case 1111:
  //         // 如果业务失败，根据不同 code 做不同处理
  //         // 比如最常见的授权过期跳登录
  //         // 特定弹窗
  //         // 跳转特定页面等

  //         location.href = xxx; // 这里的路径也可以放到全局配置里
  //         return;
  //     default:
  //         // 业务中还会有一些特殊 code 逻辑，我们可以在这里做统一处理，也可以下方它们到业务层
  //         !responseObj.config.noShowDefaultError && GLOBAL.vbus.$emit('global.$dialog.show', resData.msg);
  //         return Promise.reject(resData);
  // }
}

/**
 * 响应失败，可根据 responseError.message 和 responseError.response.status 来做监控处理
 * @param {Object} responseError
 */
export function responseFailFunc (responseError) {
  if (!axios.isCancel(responseError) && responseError.config.loading) {
    --loadingCount
    if (loadingCount <= 0) {
      fullscreenLoading && fullscreenLoading.close()
      loadingCount = 0
    }
  }
  let errorCode = -1
  if (responseError && responseError.response) {
    errorCode = responseError.response.status
    switch (responseError.response.status) {
      case 400:
        responseError.message = '错误请求'
        break
      case 401:
        responseError.message = '未授权，请重新登录'
        break
      case 403:
        responseError.message = '拒绝访问'
        break
      case 404:
        responseError.message = '请求错误,未找到该资源'
        break
      case 405:
        responseError.message = '请求方法未允许'
        break
      case 408:
        responseError.message = '请求超时'
        break
      case 500:
        responseError.message = responseError.response.data.msg || '服务器端出错'
        break
      case 501:
        responseError.message = '网络未实现'
        break
      case 502:
        responseError.message = '网络错误'
        break
      case 503:
        responseError.message = '服务不可用'
        break
      case 504:
        responseError.message = '网络超时'
        break
      case 505:
        responseError.message = 'http版本不支持该请求'
        break
      default:
        if (responseError.response.data.msg) {
          responseError.message = responseError.response.data.msg
        } else {
          responseError.message = `连接错误${responseError.response.status}`
        }
    }
  } else {
    responseError.message = '连接到服务器失败'
  }
  if (!axios.isCancel(responseError) && responseError.config.codeHandleList) {
    let handleType = 0
    for (let codeTypeData of responseError.config.codeHandleList) {
      if (errorCode === codeTypeData.code || codeTypeData.code === 'all') {
        handleType = codeTypeData.type
        break
      }
    }
    if (handleType === 0) {
      Vue.prototype.$message({
        showClose: true,
        message: responseError.message,
        type: 'error'
      })
    }
  }
  return Promise.reject(responseError)
}



// WEBPACK FOOTER //
// ./src/config/axios.js